import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { TranslationRequestDestroyInput, TranslationRequestDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationRequestDestroyInput;
type TData = TranslationRequestDestroyPayload;

export const useTranslationRequestDestroy = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestDestroy($input: TranslationRequestDestroyInput!) {
      translationRequestDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
